import React from "react";
import { motion } from "framer-motion";

export default function SectionReveal({ children }) {
  const isSmallScreen = typeof window !== "undefined" && window.innerWidth < 800;
  const duration = isSmallScreen ? 0.4 : 0.65;

  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, amount: 0.2 }}
      transition={{ duration, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}
